import React from 'react';
import { Callout, mergeStyleSets } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import LockedFeature from 'src/components/base/LockedFeature';

const styles = mergeStyleSets({
  callout: {
    maxWidth: 300,
  },
});

export default ({ plans, target, onDismiss }) => {
  const labelId = useId('callout-label');
  const descriptionId = useId('callout-description');

  return (
    <Callout
      className={styles.callout}
      // ariaLabelledBy={labelId}
      // ariaDescribedBy={descriptionId}
      role="alertdialog"
      gapSpace={0}
      // target={`.${styles.buttonArea}`}
      target={target}
      onDismiss={onDismiss}
      setInitialFocus
      styles={{ calloutMain: { overflow: 'hidden' } }}
    >
      <LockedFeature plans={plans}/>
    </Callout>
  );
}
